import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlcurrency',
  standalone: true,
})
export class HtmlCurrencyPipe implements PipeTransform {
  transform(value: number, currencyCode = 'EUR', digitsInfo = '1.2-2', locale = 'it'): string | null {
    const price = formatCurrency(value, locale, getCurrencySymbol(currencyCode, 'narrow'), currencyCode, digitsInfo);
    return `<strong>${price.substring(0, price.length - 1).trim()}</strong>${price
      .substring(price.length - 1)
      .trim()}&nbsp;`;
  }
}
